import { LitElement, css, CSSResultGroup } from "lit";

export abstract class LoanLightElement extends LitElement {
  // Note: Custom elements display inline by default. That is often surprising
  // for developers, so we override it here.
  static styles: CSSResultGroup = css`
    :host {
      display: block;
      font-family: "Instrument Sans", sans-serif;
      background-color: #f8fbfc;
    }
  `;
}
